import 'scss/solutions/cloudSolution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/cloudSolution.js